"use client";
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import parse from 'html-react-parser';
import BlogPostBody from './BlogPostBody';
import { IBlogValue } from '../../components/BlogListing';
// import BlogNotFound from '../../components/BlogNotFound/page';
import { notFound } from "next/navigation";
import ThemeSwitchAssetsNoLink from '@/utils/ThemeSwitchAssetsNoLink';
import { IGlobalAssetsProps } from '@/types/pageContent.types';
import styles from './styles.module.scss';


export interface IBlogPostViewProp {
  prevNextArrows: IGlobalAssetsProps[];
  currentBlog: IBlogValue[];
  prevBlogTitle: string;
  prevBlogLink: string;
  prevBlogImg: {
    url: string;
    alt: string;
  }

  nextBlogTitle: string;
  nextBlogLink: string;
  nextBlogImg: {
    url: string;
    alt: string;
  }
};

const BlogPostView = (
  {
    prevNextArrows, 
    currentBlog,
    prevBlogTitle,
    prevBlogLink,
    prevBlogImg,

    nextBlogTitle,
    nextBlogLink,
    nextBlogImg
  }: IBlogPostViewProp
) => {
  // console.log('BlogPostView nextBlogImg:', nextBlogImg);
  
  // Defensive fallback for nextBlogImg
  const safeNextBlogImg = nextBlogImg && nextBlogImg.url ? nextBlogImg : { url: '/fallback-image.png', alt: 'No image available' };
  const blog = currentBlog[0];

  const formatDate = (dateStr: string) => {
    try {
      const [month, day, year] = dateStr.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (e) {
      return dateStr;
    }
  };

  return (
    <div className={styles.blogPostPage}>
      <article className={styles.blogPostContainer}>
        <header className={styles.hero}>
          {blog?.blogArticleDate && (
            <p className={styles.date}>{formatDate(blog.blogArticleDate)}</p>
          )}
          <h1 className={styles.title}>
            {blog?.heading ? parse(blog.heading) : ''}
          </h1>
        </header>

        {blog?.blogArticleImage?.url && (
          <div className={styles.heroImage}>
            <Image
              src={blog.blogArticleImage.url}
              alt={blog.blogArticleImage.alt || ''}
              width={1200}
              height={800}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
              priority
            />
          </div>
        )}

        <section className={`${styles.postBody} blog_post__body`}>
          {
            blog?.body === undefined || blog?.body === null
              ? notFound()
              : <BlogPostBody 
                  blogPostBodyData={blog.body} 
                />
          }
        </section>
      </article>

      <section className={`${styles.prevNextBlogsContainer}`}>
        <h2>You might also like</h2>

        <div className={`${styles.prevNextBlogs}`}>
          <div className={`${styles.prevBlog} ${styles.blog}`}>
            {prevBlogImg && prevBlogImg.url ? (
              <Image
                src={prevBlogImg.url}
                alt={prevBlogImg.alt}
                width="500"
                height="500"
                quality={75}
              />
            ) : (
              <div style={{width:500, height:500, background:'#eee', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <span>No image available</span>
              </div>
            )}

            <Link href={`${prevBlogLink}`}>
              {/* <ThemeSwitchAssetsNoLink receivedAssets={prevNextArrows} /> */}
              <h3>{typeof prevBlogTitle === 'string' ? parse(prevBlogTitle) : ''}</h3>
            </Link>
            <Link href={`${prevBlogLink}`}>
              Read more
              <span className="sr-only">about the blog article</span>
            </Link>
          </div>

          <div className={`${styles.nextBlog} ${styles.blog}`}>
            {safeNextBlogImg.url ? (
              <Image
                src={safeNextBlogImg.url}
                alt={safeNextBlogImg.alt}
                width="500"
                height="500"
                quality={75}
              />
            ) : (
              <div style={{width:500, height:500, background:'#eee', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <span>No image available</span>
              </div>
            )}

            <Link href={`${nextBlogLink}`}>
              {/* <ThemeSwitchAssetsNoLink receivedAssets={prevNextArrows} /> */}
              <h3>{typeof nextBlogTitle === 'string' ? parse(nextBlogTitle) : ''}</h3>
            </Link>
            <Link href={`${nextBlogLink}`}>
              Read more
              <span className="sr-only">about the blog article</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default BlogPostView;
